import React from "react";

import { OneTrustCookieSettingsBlock as Value } from "@reactivated";

export const OneTrustCookieSettingsBlock = (props: {
    id: string;
    value: Value;
}): React.JSX.Element | null => {
    if (!props.value.domain_script_uuid) {
        return null;
    }
    return (
        <script
            key={`${props.id}-onetrust`}
            src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
            type="text/javascript"
            data-domain-script={props.value.domain_script_uuid}
        ></script>
    );
};
